/**
 * Flavour selector component
 */

const njamitoFlavourSelectorItemElements = document.querySelectorAll('.njamito-flavour__selector-item') as NodeListOf<HTMLInputElement>;
njamitoFlavourSelectorItemElements.forEach(anchor => {
	const parent = anchor.closest('.njamito-flavour__selector')
	const selectedLabel = parent ? parent.querySelector('.njamito-flavour__selected') : null;
	if (!selectedLabel) {
		return;
	}
	anchor.addEventListener('mouseover', function (e) {
		if (selectedLabel) {
			selectedLabel.textContent = anchor.getAttribute('title');
		}
	});
	anchor.addEventListener('mouseout', function (e) {
		selectedLabel.textContent = selectedLabel.getAttribute('data-selected');
	});
});


/**
 * Accordion component
 */

const njamitoAccordionAnchorElements = document.querySelectorAll('.njamito-accordion__type--anchor') as NodeListOf<HTMLInputElement>;

document.querySelectorAll('.njamito-accordion__type--anchor[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();
        const targetId = (anchor as HTMLAnchorElement).getAttribute('href');
        if (targetId) {
            const targetElement = document.querySelector(targetId);
            if (targetElement) {
                const rect = targetElement.getBoundingClientRect();
                const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                const targetY = rect.top + scrollTop - 80;

                window.scrollTo({
                    top: targetY,
                    behavior: 'smooth'
                });
            }
        }
    });
});

document.querySelectorAll('.njamito-accordion__item-content').forEach(content => {
    const contentHeight = content.scrollHeight;
    const contentStyle = window.getComputedStyle(content);
    const paddingTop = parseFloat(contentStyle.paddingTop);
    const paddingBottom = parseFloat(contentStyle.paddingBottom);
    const marginTop = parseFloat(contentStyle.marginTop);
    const marginBottom = parseFloat(contentStyle.marginBottom);
    const totalHeight = contentHeight + paddingTop + paddingBottom + marginTop + marginBottom;
    (content as HTMLElement).style.setProperty('--njamito-accordion-item-content-max-height', totalHeight + 'px');
});

/**
 * Quantity component
 */

//const njamitoQuantityElements = document.querySelectorAll(".njamito-quantity__input");
const njamitoQuantityElements = document.querySelectorAll(".njamito-quantity__input") as NodeListOf<HTMLInputElement>;


if (njamitoQuantityElements) {
    njamitoQuantityElements.forEach((element) => {
        const fieldId = element.id;
        const quantityAdd = document.getElementById(fieldId + "-add") as HTMLButtonElement;
        const quantitySubtract = document.getElementById(fieldId + "-subtract") as HTMLButtonElement;
        const quantityValue = document.getElementById(fieldId + "-value") as HTMLDivElement;

        // Ensure buttons exist before adding event listeners
        if (quantityAdd) {
            quantityAdd.addEventListener("click", () => {
                njamitoSetQuantity(fieldId, 1);
            });
        }

        if (quantitySubtract) {
            quantitySubtract.addEventListener("click", () => {
                njamitoSetQuantity(fieldId, -1);
            });
        }

        element.addEventListener("change", (event) => {
            const inputElement = event.target as HTMLInputElement;
            if (quantityValue) {
                quantityValue.textContent = inputElement.value;
            }
            updateButtonState(fieldId);
            updateAddToCartQuantity(element);
        });

        // Initialize button state on load
        updateButtonState(fieldId);
        updateAddToCartQuantity(element);
    });
}

function njamitoSetQuantity(fieldId: string, changeValue: number) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    const quantityValue = document.getElementById(fieldId + "-value") as HTMLDivElement;

    if (!field || !quantityValue) return;

    let newValue = parseInt(field.value) + changeValue;

    // Ensure min & max values are handled correctly
    const minValue = field.min ? parseInt(field.min) : 1;
    const maxValue = field.max ? parseInt(field.max) : Infinity;

    newValue = Math.max(minValue, Math.min(newValue, maxValue));

    field.value = newValue.toString();
    quantityValue.textContent = newValue.toString(); // Update displayed value

    field.dispatchEvent(new Event("change"));

    // Update button states after change
    updateButtonState(fieldId);
    updateAddToCartQuantity(field);
}

function updateButtonState(fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    const quantityAdd = document.getElementById(fieldId + "-add") as HTMLButtonElement;
    const quantitySubtract = document.getElementById(fieldId + "-subtract") as HTMLButtonElement;

    if (!field || !quantityAdd || !quantitySubtract) return;

    const currentValue = parseInt(field.value);
    const minValue = field.min ? parseInt(field.min) : 1;
    const maxValue = field.max ? parseInt(field.max) : Infinity;

    // Disable or enable subtract button
    quantitySubtract.disabled = currentValue <= minValue;
    quantityAdd.disabled = currentValue >= maxValue;
}

function updateAddToCartQuantity(inputElement: HTMLInputElement) {
    // Find the closest WooCommerce product container
    const productContainer = inputElement.closest(".product");
    if (!productContainer) return;

    // Find the "Add to Cart" button inside this product
    const addToCartButton = productContainer.querySelector(".add_to_cart_button") as HTMLAnchorElement;
    if (addToCartButton) {
        addToCartButton.setAttribute("data-quantity", inputElement.value);
    }
}

/**
 * Cart items count - update dynamically
 */


const cartIcon = document.querySelector(".icon--cart") as HTMLElement | null;
const cartCountBadge = document.querySelector(".icon--cart .cart-count") as HTMLElement | null;

function updateCartBadge() {
    if (!cartIcon || !cartCountBadge) return; // Ensure both elements exist

    let cartQty = cartIcon.getAttribute("data-cart-qty") || "0";
    cartCountBadge.textContent = cartQty;
    cartCountBadge.style.visibility = cartQty === "0" ? "hidden" : "visible";
}

// Initial update
updateCartBadge();


/**
 * Select-Dropdown component
 */

const njamitoSelectElements = document.querySelectorAll('.njamito-select');
if (njamitoSelectElements) {
    document.addEventListener("click", (event) => {
        njamitoSelectElements.forEach((select) => {
            const id = select.getAttribute('data-id');
            const input = id ? document.getElementById(id) as HTMLInputElement : null;
            if (input && !select.contains(event.target as Element)) {
                input.checked = false;
            }
        });
    });
}